import http, { httpWrapper } from 'services/http';
import { v4 as uuidv4 } from 'uuid';
import userService from 'services/user';
import { store } from 'initStore';
import { API_URL_PAS2, API_KEY_PAS2, ENDPOINT_PAYMENTS } from 'constants.js';
import { getThreeDsColorDepth } from 'utils/threeDsUtil';
import { endpoint } from '.';

const read = async () => {
  const authHeaders = await userService.getAuthorizationHeaders();

  const requestOptions = {
    method: 'GET',
    url: `${endpoint(ENDPOINT_PAYMENTS)}`,
    headers: {
      ...authHeaders,
    },
  };

  const response = http(requestOptions);
  return response;
};

const update = async payload => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'PUT',
    url: `${endpoint(ENDPOINT_PAYMENTS)}/${payload.id}`,
    headers: {
      ...authHeaders,
    },
    data: payload,
  };

  const response = http(requestOptions);
  return response;
};

const destroy = async id => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'DELETE',
    url: `${endpoint(ENDPOINT_PAYMENTS)}/${id}`,
    headers: {
      ...authHeaders,
    },
  };

  const response = http(requestOptions);
  return response;
};

// Turning sharing off also revokes any driver access the card already had.
const setSharing = async ({ paymentAccountId, sharedWithDrivers }) => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'PATCH',
    url: `${endpoint(ENDPOINT_PAYMENTS)}/${paymentAccountId}/sharing`,
    headers: {
      ...authHeaders,
    },
    data: { sharedWithDrivers },
  };

  return httpWrapper(requestOptions);
};

// PAS 2.0 endpoints
const pasHeaders = {
  'X-Pbp-ClientType': 'businessapp',
  'X-Api-Key': API_KEY_PAS2,
};

const readOne = async (paymentId, workflowId) => {
  const authHeaders = await userService.getAuthorizationHeaders();

  const requestOptions = {
    method: 'GET',
    url: `${API_URL_PAS2}/${paymentId}`,
    headers: {
      ...authHeaders,
      ...pasHeaders,
      'X-Pbp-WorkflowId': workflowId,
    },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const create = async card => {
  const { recaptchaToken, ...cardData } = card;
  const currentLanguage = store && store.getState().user.currentCorporation.preferredLanguage;
  const authHeaders = await userService.getAuthorizationHeaders();
  const createPaymentHeaders = {
    'Accept-Language': currentLanguage,
    'X-Pbp-ClientColorDepth': getThreeDsColorDepth(window.screen.colorDepth),
    'X-Pbp-ClientJavaEnabled': 'false',
    'X-Pbp-ClientScreenHeight': '288',
    'X-Pbp-ClientScreenWidth': '672',
    'X-Pbp-ClientTimeZoneOffsetMinutes': new Date().getTimezoneOffset().toString(),
    'X-Pbp-VerificationToken': recaptchaToken,
    'X-Pbp-ClientType': 'businessapp',
    'x-pbp-recaptchatype': 'score',
  };

  const workflowId = uuidv4();
  const requestOptions = {
    method: 'POST',
    url: API_URL_PAS2,
    headers: {
      ...authHeaders,
      ...createPaymentHeaders,
      ...pasHeaders,
      'X-Pbp-WorkflowId': workflowId,
    },
    data: {
      ...cardData,
      scope: 'Shared',
    },
  };

  try {
    const response = await httpWrapper(requestOptions);
    return {
      response,
      workflowId,
    };
  } catch (e) {
    e.workflowId = workflowId;
    throw e;
  }
};

export default {
  read,
  readOne,
  create,
  update,
  destroy,
  setSharing,
};
